<template>
  <div>
    <div class="form-group">
      <label v-if="label">{{ label }}</label>
      <v-select
          v-bind="$attrs"
          v-on="$listeners"
          v-model="internalValue"
          :options="options"
          :label="name"
          :filterable="filterable"
          :reduce="useReduce ? option => option[trackBy] : undefined"
          :taggable="taggable"
          :append-to-body="appendToBody"
          :multiple="$attrs.multiple"
          :loading="loading"
          @option:selecting="onSelecting"
          @option:selected="onSelect"
          @option:deselecting="onRemoving"
          @option:deselected="onRemove"
          @search="search"
          class="fix-dropdown"
      >
        <template #no-options="{ search, searching, loading }">
          <slot name="no-options" :search="search" :searching="searching" :loading="loading">
            <span v-if="loading">Searching...</span>
            <span v-else-if="searching">No results for "{{ search }}"</span>
            <span v-else>Type to search</span>
          </slot>
        </template>
      </v-select>
      <validation-error :errors="error" />
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import ValidationError from '../ValidationError';

export default {
  name: 'SelectInput',
  components: {
    vSelect,
    ValidationError
  },
  props: {
    value: [String, Number, Object, Array, null],
    options: {
      type: Array,
      default: () => []
    },
    trackBy: {
      type: String,
      default: 'id'
    },
    name: {
      type: String,
      default: 'name'
    },
    label: {
      type: String,
      default: ''
    },
    taggable: {
      type: Boolean,
      default: false
    },
    error: {
      type: Array,
      default: () => []
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    reduceToValue: {
      type: Boolean,
      default: true
    },
    filterable: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    useReduce () {
      return this.reduceToValue;
    },
    internalValue: {
      get () {
        if (this.value === undefined || this.value === null) {
          return this.$attrs.multiple ? [] : null;
        }
        return this.value;
      },
      set (val) {
        this.$emit('input', val);

        let fullValue = val;
        if (this.useReduce && val !== null) {
          fullValue = this.$attrs.multiple
              ? this.options.filter(opt => val.includes(opt[this.trackBy]))
              : this.options.find(opt => opt[this.trackBy] === val) || null;
        }
        this.$emit('fullValueChange', fullValue);
      }
    }
  },
  methods: {
    onSelect (option) {
      this.$emit('select', option);
    },
    onSelecting (option) {
      this.$emit('selecting', option);
    },
    onRemove (option) {
      const output = this.getFullObject(option);
      this.$emit('remove', output);
    },
    onRemoving (option) {
      const output = this.getFullObject(option);
      this.$emit('removing', output);
    },
    search (searchValue, loading) {
      this.$emit('search', searchValue, loading);
    },
    getFullObject (option) {
      if (this.useReduce && option !== null && typeof option !== 'object') {
        return this.options.find(opt => opt[this.trackBy] === option) || option;
      }
      return option;
    }
  }
};
</script>

<style scoped>
.v-select .vs__dropdown-menu {
  z-index: 9999 !important;
}
</style>